import { Pipe, PipeTransform } from '@angular/core';

import { ENavbarItemType, TNavigation } from '@app/shared/components/under-ui-header/types/navbar-item.type';

export function matchesPrefix(currentUrl: string, path: string): boolean {
  const urlPath = currentUrl.split('?')[0];
  const normalized = path.startsWith('/') ? path : '/' + path;
  return urlPath === normalized || urlPath.startsWith(normalized + '/');
}

@Pipe({
  name: 'isChildActive',
  standalone: true,
  pure: true,
})
export class IsChildActivePipe implements PipeTransform {
  transform(child: TNavigation, currentUrl: string, activeOverride: string | null = null): boolean {
    if (child.type !== ENavbarItemType.Link) {
      return false;
    }

    if (activeOverride) {
      return child.path === activeOverride;
    }

    return matchesPrefix(currentUrl, child.activePath ?? child.path);
  }
}
